import { useSelector, useDispatch } from 'react-redux';
import { set, unSet } from '../store/userClinic/userClinicSlice';
import {
  clearOnLocalStorage,
  getFromLocalStorage,
  setOnLocalStorage,
} from '../utils/user-clinic';

export const useUserLocale = () => {
  const userLocale = useSelector((state) => {
    return state.rootReducer.locale.value;
  });
  const dispatch = useDispatch();

  const getUserLocale = () => getFromLocalStorage();

  const setUserLocale = (clinic) => {
    if (!clinic) return;
    dispatch(set(clinic));
    setOnLocalStorage(clinic);
  };
  const unSetUserLocale = () => {
    dispatch(unSet());
    clearOnLocalStorage();
  };

  return {
    userLocale,
    setUserLocale,
    unSetUserLocale,
    getUserLocale,
  };
};
